<template>
    <section v-show="visibleCount > 0" :id="id" class="scroll-mt-32">
        <div class="mb-4 flex flex-wrap items-baseline gap-x-3 gap-y-1 border-b border-border pb-2">
            <h2 class="title-subsection text-ink">{{ title }}</h2>
            <span class="scaffold-details-small text-ink-muted">{{ visibleCount }} of {{ entries.length }}</span>
            <p v-if="description" class="body-small text-ink-muted basis-full">{{ description }}</p>
        </div>
        <!-- Multicol rather than a grid so cards pack tightly instead of leaving a row-height gap beside every short demo. -->
        <div class="columns-1 gap-6 xl:columns-2">
            <slot />
        </div>
    </section>
</template>

<script lang="ts">
interface DesignSystemSectionProps {
    id: string;
    title: string;
    description?: string;
}
</script>

<script setup lang="ts">
import { computed, inject, provide, shallowReactive } from "vue";

import { designSystemPageKey, designSystemSectionKey, type RegisteredEntry } from "./context";

const props = defineProps<DesignSystemSectionProps>();

const entries = shallowReactive<RegisteredEntry[]>([]);
provide(designSystemSectionKey, (entry: RegisteredEntry) => entries.push(entry));

const visibleCount = computed(() => entries.filter((entry) => entry.visible.value).length);

const registerSection = inject(designSystemPageKey, undefined);
registerSection?.({
    id: props.id,
    title: props.title,
    total: computed(() => entries.length),
    visible: visibleCount,
});
</script>
